import { ReactNode, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

/** Slot under the booking card in pages/booking/[slug].tsx — empty unless something is portaled into it. */
export const BOOKING_PAGE_FOOTER_ID = 'booking-page-footer';

/**
 * At the bottom of the booking page, outside the white booking card, on the page background (e.g. the clinic's
 * support contact). Rendered in place where the page has no slot (another page using BookingSteps).
 */
export const BookingPageFooter = ({ children }: { children: ReactNode }) => {
  // undefined until mounted (nothing rendered, so it never shows in the card first and then jumps), null = no slot
  const [slot, setSlot] = useState<HTMLElement | null | undefined>(undefined);
  useEffect(() => setSlot(document.getElementById(BOOKING_PAGE_FOOTER_ID)), []);

  if (slot === undefined) return null;
  const content = (
    <div className="px-5 pt-2 pb-8" data-testid="booking-page-footer">
      {children}
    </div>
  );
  return slot ? createPortal(content, slot) : content;
};

export default BookingPageFooter;
